"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotBulkDeleteAction = exports.BRANCH_PERM_INDEX = void 0;
exports.getUrlParam = getUrlParam;
exports.getSearchParam = getSearchParam;
exports.toOplusTime = toOplusTime;
exports.fromOplusTime = fromOplusTime;
exports.kitchenTimeToDuration = kitchenTimeToDuration;
exports.durationToKitchenTime = durationToKitchenTime;
exports.getNanosecondsFromDateString = getNanosecondsFromDateString;
exports.jpMinutesString = jpMinutesString;
exports.extractHourAndMinFromKitchenTime = extractHourAndMinFromKitchenTime;
exports.simpleTimeString = simpleTimeString;
exports.monthDateTimeString = monthDateTimeString;
exports.isSameDay = isSameDay;
exports.dateFromString = dateFromString;
exports.yearMonthDateString = yearMonthDateString;
exports.shortDateLabel = shortDateLabel;
exports.jpShortDateString = jpShortDateString;
exports.jpDateString = jpDateString;
exports.hourStringTz = hourStringTz;
exports.dateToKitchenTime = dateToKitchenTime;
exports.datesToKitchenTimeRange = datesToKitchenTimeRange;
exports.fullWidthToAscii = fullWidthToAscii;
exports.timespansOverlapIncl = timespansOverlapIncl;
exports.extractTimeAndMin = extractTimeAndMin;
exports.removeWhiteSpace = removeWhiteSpace;
exports.getBitPos = getBitPos;
exports.setSingleBit = setSingleBit;
exports.parseHourAndMin = parseHourAndMin;
exports.getListViewUrl = getListViewUrl;
exports.isErrorDate = isErrorDate;
exports.parseMaxMonthLaborMinutesRaw = parseMaxMonthLaborMinutesRaw;
exports.computeOverflowedSlots = computeOverflowedSlots;
exports.characterGroup = characterGroup;
exports.sortTags = sortTags;
const luxon_1 = require("luxon");
const common_1 = require("../js/common");
const isoDayToKanji_1 = __importDefault(require("./isoDayToKanji"));
var BRANCH_PERM_INDEX;
(function (BRANCH_PERM_INDEX) {
    BRANCH_PERM_INDEX[BRANCH_PERM_INDEX["OWNER"] = 0] = "OWNER";
    BRANCH_PERM_INDEX[BRANCH_PERM_INDEX["EDITOR"] = 1] = "EDITOR";
    BRANCH_PERM_INDEX[BRANCH_PERM_INDEX["STAFF"] = 2] = "STAFF";
    BRANCH_PERM_INDEX[BRANCH_PERM_INDEX["VIEWER"] = 3] = "VIEWER";
})(BRANCH_PERM_INDEX || (exports.BRANCH_PERM_INDEX = BRANCH_PERM_INDEX = {}));
var SlotBulkDeleteAction;
(function (SlotBulkDeleteAction) {
    SlotBulkDeleteAction["All"] = "all";
    SlotBulkDeleteAction["UnlockOnly"] = "unlocked";
    SlotBulkDeleteAction["Selected"] = "selected";
})(SlotBulkDeleteAction || (exports.SlotBulkDeleteAction = SlotBulkDeleteAction = {}));
function getUrlParam(query) {
    const search = window.location.search.substring(1);
    const vars = search.split("&");
    for (let i = 0; i < vars.length; i++) {
        const item = vars[i];
        if (!item)
            continue;
        const pair = item.split("=");
        if (pair[0] == query) {
            if (pair[1] === undefined) {
                return "";
            }
            return decodeURIComponent(pair[1]);
        }
    }
    return "";
}
function getSearchParam(strParams) {
    const params = {};
    const source = strParams ? `?${strParams}` : window.location.href;
    source.replace(/[?&]+([^=&]+)=([^&]*)/g, (_, key, value) => {
        params[key] = decodeURIComponent(value);
        return '';
    });
    return params;
}
function toOplusTime(date) {
    const d = luxon_1.DateTime.fromJSDate(date, { zone: "UTC" });
    if (!d.isValid) {
        throw new Error('invalid date');
    }
    const str = d.setZone("Asia/Tokyo").toISO();
    if (!str) {
        throw new Error('invalid date');
    }
    const oplusTime = luxon_1.DateTime.fromISO(str.replace("+09:00", "Z"));
    return oplusTime.toJSDate();
}
function fromOplusTime(date) {
    const d = new Date(date);
    const str = d.toISOString();
    const real = luxon_1.DateTime.fromISO(str.replace("Z", "+09:00"), { zone: "Asia/Tokyo" });
    return real.toJSDate();
}
function kitchenTimeToDuration(kitchenTime, unitsOut) {
    let hours = 0;
    let mins = 0;
    if (typeof (kitchenTime) == 'number') {
        mins = kitchenTime;
    }
    else if (typeof (kitchenTime) == 'string') {
        // Note: this block is temporary and should be removed once we standardize types or Rest from BE
        const digits = new RegExp(/^[0-9]*$/);
        if (kitchenTime.match(digits)) {
            mins = parseInt(kitchenTime) || 0;
        }
        else {
            const sp = kitchenTime.split(":");
            const [hourString, minuteString, err] = sp;
            if (hourString === undefined || minuteString === undefined || err) {
                throw new Error('invalid kitchen time');
            }
            hours = parseInt(hourString);
            mins = parseInt(minuteString);
        }
    }
    else {
        throw new Error('invalid kitchen time input type');
    }
    const d = luxon_1.Duration.fromObject({
        hours: hours,
        minutes: mins,
    });
    if (!d.isValid) {
        throw new Error('invalid duration');
    }
    return d.as(unitsOut);
}
function durationToKitchenTime(duration, unitsIn) {
    let d;
    if (unitsIn === 'hours') {
        d = luxon_1.Duration.fromObject({ hours: duration });
    }
    else if (unitsIn === 'minutes') {
        d = luxon_1.Duration.fromObject({ minutes: duration });
    }
    else {
        throw new Error('invalid units');
    }
    if (!d.isValid) {
        throw new Error('invalid duration');
    }
    return d.toFormat("hh:mm");
}
function getNanosecondsFromDateString(dateString) {
    const fractionalPartMatch = dateString.match(/\.(\d+)Z$/);
    let nanoseconds = 0;
    if (fractionalPartMatch) {
        const fractionalPart = fractionalPartMatch[0];
        nanoseconds = parseFloat(fractionalPart) * 1_000_000_000;
    }
    return nanoseconds;
}
// Returns the minute rounded up to the nearest whole minute
function jpMinutesString(secs) {
    const min = Math.floor((secs + 59) / 60);
    return `${min}分`;
}
function extractHourAndMinFromKitchenTime(kitchenTime) {
    let hours = 0;
    let mins = 0;
    if (typeof (kitchenTime) == 'string') {
        const sp = kitchenTime.split(":");
        const [hourString, minuteString, err] = sp;
        if (hourString === undefined || minuteString === undefined || err) {
            throw new Error('invalid kitchen time');
        }
        hours = parseInt(hourString, 10);
        mins = parseInt(minuteString, 10);
    }
    return {
        hour: hours,
        minute: mins,
    };
}
// Returns time with format H:MM in system's time zone
function simpleTimeString(date) {
    const hours = date.getHours();
    const minutes = (0, common_1.addZeroPlaceholders)(date.getMinutes());
    return `${hours}:${minutes}`;
}
// Returns date and time with format MM/DD H:MM in system's time zone
function monthDateTimeString(date) {
    const hours = date.getHours();
    const minutes = (0, common_1.addZeroPlaceholders)(date.getMinutes());
    const month = (0, common_1.addZeroPlaceholders)(date.getMonth() + 1);
    const day = (0, common_1.addZeroPlaceholders)(date.getDate());
    return `${month}/${day} ${hours}:${minutes}`;
}
function isSameDay(start, end) {
    return start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth() && start.getDate() === end.getDate();
}
function dateFromString(dateStr, timeZone) {
    const d = luxon_1.DateTime.fromFormat(dateStr, "yyyy-MM-dd", { zone: timeZone });
    if (!d.isValid) {
        throw new Error('invalid date string');
    }
    return d.toJSDate();
}
function yearMonthDateString(t, timeZone) {
    const d = luxon_1.DateTime.fromJSDate(t, { zone: timeZone });
    return `${d.year}-${(0, common_1.addZeroPlaceholders)(d.month)}-${(0, common_1.addZeroPlaceholders)(d.day)}`;
}
// Short date label format with optional weekday: 1/5(月)
function shortDateLabel(t, tz, includeWeekdayKanji = true) {
    const d = luxon_1.DateTime.fromJSDate(t, { zone: tz });
    if (!d.isValid) {
        throw new Error('invalid date');
    }
    return `${d.month}/${d.day}${includeWeekdayKanji ? ` (${isoDayToKanji_1.default[d.weekday]})` : ''}`;
}
// JP Short Date format with optional weekday: 1月5日 (月)
function jpShortDateString(t, tz, includeWeekdayKanji = true) {
    const d = luxon_1.DateTime.fromJSDate(t, { zone: tz });
    if (!d.isValid) {
        throw new Error('invalid date');
    }
    return `${d.month}月${d.day}日${includeWeekdayKanji ? ` (${isoDayToKanji_1.default[d.weekday]})` : ''}`;
}
// JP Full Date with weekday format: 2023年1月5日 (月)
function jpDateString(t, tz, showWeekday = true) {
    const d = luxon_1.DateTime.fromJSDate(t, { zone: tz });
    if (!d.isValid) {
        throw new Error('invalid date');
    }
    let dateStr = `${d.year}年${d.month}月${d.day}日`;
    if (showWeekday) {
        dateStr += ` (${isoDayToKanji_1.default[d.weekday]})`;
    }
    return dateStr;
}
// Return an hour string "10", "09" with zero placeholder for the given time zone.
// Will throw an error if the date is invalid.
function hourStringTz(t, tz) {
    const d = luxon_1.DateTime.fromJSDate(t, { zone: tz });
    if (!d.isValid) {
        throw new Error('invalid date');
    }
    return (0, common_1.addZeroPlaceholders)(d.hour);
}
// TODO: doc and tests
function dateToKitchenTime(t, tz = "Asia/Tokyo") {
    const d = luxon_1.DateTime.fromJSDate(t, { zone: tz });
    if (!d.isValid) {
        throw new Error('invalid date');
    }
    return d.toFormat("HH:mm");
}
// Kitchen time range format: "10:00-18:00", "10:00-", or "-18:00"
function datesToKitchenTimeRange(start, end, tz = "Asia/Tokyo") {
    const fromStr = dateToKitchenTime(start, tz);
    const toStr = dateToKitchenTime(end, tz);
    const fromIsError = (0, common_1.isZeroDate)(start) || isErrorDate(start);
    const toIsError = (0, common_1.isZeroDate)(end) || isErrorDate(end);
    if ((fromIsError && toIsError) || (!fromStr && !toStr)) {
        return "";
    }
    if (!fromStr || fromIsError) {
        return `~ ${toStr}`;
    }
    if (!toStr || toIsError) {
        return `${fromStr} ~`;
    }
    return `${fromStr} ~ ${toStr}`;
}
/*
  Note: We have the same function in dashboard_base.html, but please use this version from now on
  FullWidthToAscii converts full-width characters to their ascii7 counterpart
  the space is the U+3000, the ideographic space used in Japanese.
  Non-strings are returned immutated.

  In particular, the conversion is from the following characters:
  ！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠
  ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀
  ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝～

  To the following ones:
  !"#$%&\'()*+,-./0123456789:;<=>?@
  ABCDEFGHIJKLMNOPQRSTUVWXYZ[\]^_`
  abcdefghijklmnopqrstuvwxyz{|}~

  Plus from the ideographic space U+3000 "　" to the space U+20 " ".
*/
function fullWidthToAscii(str) {
    if (typeof str !== 'string') {
        console.error(`fullWidthToAscii called with anon string ${typeof (str)}! ${str}`);
        return "";
    }
    return str.replace(/[　！-～]/g, (fwTextChr) => {
        if (fwTextChr === "　") {
            return ' ';
        }
        // 0xFEE0 is the codepoint distance between the two blocks
        const codePoint = fwTextChr.codePointAt(0);
        if (codePoint !== undefined) {
            return String.fromCodePoint(codePoint - 0xFEE0);
        }
        return fwTextChr;
    });
}
// timeSpansOverlapIncl returns true if the time ranges s1(start1)->e1(end1) and s2->e2 overlap.
// timespansOverlapIncl also includes situations where s1 equals e2 or s2 equals e1, unlike timespansOverlap.
function timespansOverlapIncl(s1, e1, s2, e2) {
    return s1 <= e2 && s2 <= e1;
}
function extractTimeAndMin(str, overnight) {
    function toString() {
        if (!isValid) {
            return "";
        }
        const strHour = String(t?.hour);
        const strMin = String(t?.min);
        return '00'.slice(0, -strHour.length) + strHour + ':00'.slice(0, -strMin.length) + strMin;
    }
    let isValid = false;
    const t = parseHourAndMin(str);
    if (t == null) {
        return { toString, isValid };
    }
    const maxHour = !overnight ? 24 : 48;
    isValid = t.hour < maxHour && t.min < 60;
    t.hour %= 24;
    return { hour: t.hour, min: t.min, toString, isValid };
}
function removeWhiteSpace(str) {
    return str.replace(/\s/g, "");
}
function getBitPos(n, pos) {
    return 1 & (n >> pos);
}
function setSingleBit(n, pos, newBit) {
    const clearMask = ~(1 << pos);
    return (n & clearMask) | (newBit << pos);
}
function parseHourAndMin(str) {
    str = fullWidthToAscii(String(str)).trim();
    let rv = null;
    str.replace(/^([0-9]{1,2})(?:[^0-9]([0-9]{1,2})[^0-9]?)?$|^([0-9]{4})$/, (_, iHour, iMin, rawHour) => {
        const t = { hour: 0, min: 0 };
        if (rawHour) {
            t.hour = Math.floor(Number(rawHour) / 100);
            t.min = Number(rawHour) % 100;
        }
        else {
            t.hour = Number(iHour) || 0;
            t.min = iMin ? Number(iMin) : 0;
        }
        rv = t;
        return '';
    });
    return rv;
}
function getListViewUrl(start, activeBranchId, list = "custom", until, paramToPass = []) {
    let param = {
        list,
        date: start,
        tags: getUrlParam("tags"),
        roles: getUrlParam("roles"),
        workerOnly: getUrlParam("workerOnly"),
        lockedOnly: getUrlParam("lockedOnly"),
        c: activeBranchId,
    };
    if (until) {
        param.until = until;
    }
    if (paramToPass.length) {
        param = pushURLParmToParmObj(param, paramToPass);
    }
    const url = window.location.origin + window.location.pathname;
    return `${url}?${new URLSearchParams(param).toString()}`;
}
// Copied from Dashboard
function pushURLParmToParmObj(paramObj, params) {
    if (typeof (params) === 'string') {
        params = [params];
    }
    if (!Array.isArray(params)) {
        return paramObj;
    }
    const splitUrl = window.location.href.split('?');
    const p = getSearchParam(splitUrl[1]);
    for (var i = 0; i < params.length; i++) {
        const pName = params[i];
        if (!pName) {
            continue;
        }
        const pValue = p[pName];
        if (!pValue) {
            continue;
        }
        paramObj[pName] = pValue;
    }
    return paramObj;
}
// Error date equivalent to Go's ErrorDate(): 0001-01-01T01:00:00Z
function isErrorDate(date) {
    return (date.getUTCFullYear() === 1 &&
        date.getUTCMonth() === 0 &&
        date.getUTCDate() === 1 &&
        date.getUTCHours() === 1 &&
        date.getUTCMinutes() === 0 &&
        date.getUTCSeconds() === 0 &&
        date.getUTCMilliseconds() === 0);
}
function parseMaxMonthLaborMinutesRaw(rawValue) {
    if (rawValue !== undefined && rawValue > 0) {
        return durationToKitchenTime(rawValue - 1, "minutes"); // +1 minute in the backend
    }
    return "";
}
// computes the number of slots given its height and container parent's height
function computeOverflowedSlots(slotCount, totalSlotHeight, slotContainerHeight) {
    // compute height of each slot
    const oneSlot = totalSlotHeight / slotCount;
    if (isNaN(oneSlot)) {
        return 0;
    }
    // calc the difference of container height and total slot height,
    // the text showing the number of overflowed slot is also take into consideration, hence the +oneSlot
    const overflowedHeight = (totalSlotHeight + oneSlot) - slotContainerHeight;
    return Math.ceil(overflowedHeight / oneSlot);
}
// Equivalent of backend's: func characterGroup(r rune)
function characterGroup(ch) {
    const code = ch.codePointAt(0);
    // Hiragana: U+3040–309F
    // Katakana: U+30A0–30FF
    // Han (CJK Unified Ideographs): U+4E00–9FFF
    if ((code >= 0x3040 && code <= 0x309F) ||
        (code >= 0x30A0 && code <= 0x30FF) ||
        (code >= 0x4E00 && code <= 0x9FFF)) {
        return 0;
    }
    // unicode.IsLetter
    if (/\p{L}/u.test(ch)) {
        return 1;
    }
    // unicode.IsNumber
    if (/\p{N}/u.test(ch)) {
        return 2;
    }
    return 3;
}
// Equivalent of backend's: (tagNamespace) Sort(tags []string)
function sortTags(tags) {
    const collator = new Intl.Collator('ja');
    tags.sort((a, b) => {
        const bChars = [...b.tag];
        let i = 0;
        for (const aChar of a.tag) {
            const bChar = bChars[i];
            if (bChar === undefined) {
                return 1;
            }
            if (aChar === bChar) {
                i++;
                continue;
            }
            const aGroup = characterGroup(aChar);
            const bGroup = characterGroup(bChar);
            if (aGroup < bGroup)
                return -1;
            if (bGroup < aGroup)
                return 1;
            // Same group → Japanese collation
            return collator.compare(aChar, bChar);
        }
        return -1;
    });
    return tags;
}
